'use strict';

import React from 'react';
import HitEvaluator from './hitEvaluator.component';
import NavigationTabs from 'components/clarity-ui/components/tabs/navigationTabs';
import PageNotification from 'components/clarity-ui/components/pageNotification';
import Tab from 'components/clarity-ui/components/tabs/tab';
import _ from 'lodash';

class Mturk extends React.Component {

  getQaEnabled (turkQaEnabled) {
    const enabledOp = ''
          .concat(turkQaEnabled.videoQaEnabled ? 'Video, ' : '')
          .concat(turkQaEnabled.pageQaEnabled ? 'Screenshot, ' : '')
          .concat(turkQaEnabled.imageQaEnabled ? 'Image, ' : '')
          .concat(turkQaEnabled.boxQaEnabled ? 'Box, ' : '');
    return _.trimRight(enabledOp, ', ');
  }

  renderPageNotification (pageNotification) {
    return (
      <div className="BreakLine">
        <PageNotification type={pageNotification.type}>
          { pageNotification.msg }
        </PageNotification>
      </div>
    );
  }

  render() {
    const { turkQaEnabled, handleMTurkNavTabChange, mturkActiveTab,
      pageNotification, loadingComponent, mturkHitEvaluator,
      handleHitEvaluatorInputOnChange, handleSaveHitEvaluatorOnClick } = this.props;
    const currentlyEnabled = this.getQaEnabled(turkQaEnabled);
    const title = mturkActiveTab.replace('mturk', '');
    const enabled = !!turkQaEnabled[title.toLowerCase()+'QaEnabled'] ? turkQaEnabled[title.toLowerCase()+'QaEnabled'] : false;
    const loadingMturkEvaluator = loadingComponent === 'mturkEvaluator';
    return (
      <div>
        <div className="EntityShowCase">
          Currently Enabled: { _.isEmpty(currentlyEnabled) ? 'None' : currentlyEnabled }
        </div>
        {
          pageNotification.show && pageNotification.target === 'mturkEvaluator'
          ? this.renderPageNotification(pageNotification)
          : null
        }
        <div>
          <NavigationTabs isVertical>
            <Tab id="mturkVideo" onClick={handleMTurkNavTabChange} isActive={mturkActiveTab === 'mturkVideo'}>Video</Tab>
            <Tab id="mturkPage" onClick={handleMTurkNavTabChange} isActive={mturkActiveTab === 'mturkPage'}>Screenshot</Tab>
            <Tab id="mturkImage" onClick={handleMTurkNavTabChange} isActive={mturkActiveTab === 'mturkImage'}>Image</Tab>
            <Tab id="mturkBox" onClick={handleMTurkNavTabChange} isActive={mturkActiveTab === 'mturkBox'}>Box</Tab>
          </NavigationTabs>
          <div className="EntityShowCase vertical">
            <HitEvaluator
              loading={loadingMturkEvaluator}
              title={title}
              enabled={enabled}
              mturkHitEvaluator={mturkHitEvaluator}
              handleHitEvaluatorInputOnChange={handleHitEvaluatorInputOnChange}
              handleSaveHitEvaluatorOnClick={handleSaveHitEvaluatorOnClick}/>
          </div>
        </div>
      </div>
    );
  }
}

export default Mturk;



// WEBPACK FOOTER //
// ./src/components/classifier/classifierTargets/mturk/mturk.component.jsx